import { render, staticRenderFns } from "./supplierReturnGoodsTask.vue?vue&type=template&id=0ad36c6a&scoped=true"
import script from "./supplierReturnGoodsTask.vue?vue&type=script&lang=js"
export * from "./supplierReturnGoodsTask.vue?vue&type=script&lang=js"
import style0 from "./supplierReturnGoodsTask.vue?vue&type=style&index=0&id=0ad36c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad36c6a",
  null
  
)

export default component.exports